import { FC, memo } from 'react';
import { Tag } from '@timeedit/ui-components';

type Props = {
  criteria: { attribute: string; value: string }[];
};

const MatchingCriteria: FC<Props> = (props) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
      }}
    >
      {props.criteria.map((v, i) => (
        <div key={`${v.attribute}-${v.value}-${i}`}>
          <Tag>{v.attribute}</Tag>
          <span style={{ marginInline: '8px' }}>{'='}</span>
          <Tag>{v.value}</Tag>
        </div>
      ))}
    </div>
  );
};

export default memo(MatchingCriteria);
